var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemocraticRepublicOfCongo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2231 8.66373C29.4838 7.23129 28.5147 5.88679 27.314 4.68604C26.1132 3.48523 24.7686 2.51617 23.3362 1.77692L12.0644 12.0648L1.77649 23.3366C2.5158 24.769 3.48486 26.1136 4.68561 27.3144C5.88636 28.5151 7.23093 29.4842 8.6633 30.2235L19.9351 19.9355L30.2231 8.66373Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 27.3141C5.35698 27.9853 6.07316 28.5839 6.82435 29.111L29.1108 6.82438C28.5839 6.07319 27.9853 5.35701 27.3141 4.68582C26.6429 4.01463 25.9267 3.41607 25.1755 2.88907L2.88904 25.1756C3.41598 25.9266 4.01454 26.6429 4.68579 27.3141V27.3141Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68576 4.68584C-0.362177 9.73377 -1.33124 17.3149 1.77664 23.3365L23.3364 1.77677C17.3148 -1.33104 9.73363 -0.361851 4.68576 4.68584V4.68584Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.314 27.314C32.3619 22.2662 33.3309 14.685 30.2232 8.66348L8.66345 30.2232C14.685 33.331 22.2662 32.362 27.314 27.314V27.314Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52689 4.86926L9.39026 7.52658H12.1843L9.92389 9.16883L10.7873 11.8261L8.52689 10.1838L6.26639 11.8261L7.12989 9.16883L4.86938 7.52658H7.66339L8.52689 4.86926Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemocraticRepublicOfCongo);
export default __webpack_public_path__ + "static/media/democratic-republic-of-congo.c15b644b.svg";
export { ForwardRef as ReactComponent };